import * as React from 'react';

interface IReset {
    color: string; // ex: #f03742
}
const ResetIcon: React.FC<IReset> = (props) => {
    const { color } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 16 16"
            style={{ margin: '0 5px 0 2px' }}
        >
            <g fill="none" fillRule="evenodd">
                <g fill={color}>
                    <g>
                        <g>
                            <g>
                                <path
                                    d="M12 10L15 14 9 14z"
                                    transform="translate(-1242 -315) translate(155 123) translate(20 18) translate(1067 172) matrix(1 0 0 -1 0 24)"
                                />
                                <path
                                    fillRule="nonzero"
                                    d="M6.5 3c3.512 0 6.373 2.785 6.496 6.267L13 9.5h-1C12 6.462 9.538 4 6.5 4S1 6.462 1 9.5c0 2.963 2.344 5.38 5.279 5.496L6.5 15v1C2.91 16 0 13.09 0 9.5S2.91 3 6.5 3z"
                                    transform="translate(-1242 -315) translate(155 123) translate(20 18) translate(1067 172)"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default ResetIcon;
